import {  Grid, Button, IconButton } from '@material-ui/core';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core/';
import BannerComponent from './BannerComponent';

const BannerDialog = ( {open,title,message,buttonlabel,allowlogin} )=>{

    return (
        <Dialog fullWidth={true} open={open} maxWidth='md' disableBackdropClick disableEscapeKeyDown  aria-labelledby="max-width-dialog-title">
            <DialogTitle id="verify-authapp-user-dilaog">{title}</DialogTitle>
            <DialogContent style={{marginBottom:'24px'}}>                                    
                <BannerComponent
                    bannerMessage={message}
                    bannerWidth="100%"
                >
                </BannerComponent>
            </DialogContent>
        </Dialog>
    );
}
export default BannerDialog;